import { Boxes, PriceDVGT } from "../models";

export class ShipmentCalculateViewModel {
    disCount: number;
    priceListId: number;
    priceServiceId: number;
    orderDate: any;
    fromHubId: number;
    fromHubIdNew: number;
    senderId: number;
    fromDistrictId: number;
    fromWardId: number;
    fromWardIdNew: number;
    toDistrictId: number;
    weight: number;
    serviceId: number;
    paymentTypeId: number;
    structureId: number;
    cod: number;
    insured: number;
    otherPrice: number;
    serviceDVGTIds: number[];
    isAgreementPrice: boolean;
    defaultPrice: number;
    totalItem: number;
    calWeight: number;
    toWardId: number;
    toWardIdNew: number;
    priceBox: Boxes[];
    priceDVGTs: PriceDVGT[];
    priceReturn: number;
    distance: number;
    totalBox: number;
    isReturn: boolean;
}